import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-12">
          {/* <div className="form-container"> */}
            <div className="image-container">
              <Link to="/">
                <img src="/logo192.png" alt="logo" className="centered-image" />
              </Link>
            </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default Header;